import {
    Box, useTheme, Chip, Autocomplete, FormControl, List, ListItem, ListItemText, TextField, Divider, Grid, Card, CardContent, Typography, IconButton, Tooltip,
} from "@mui/material";
import FolderIcon from '@mui/icons-material/FolderOutlined';

import React, { useState, useEffect } from 'react';
import { tokens } from "../../theme/theme";
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import Amendicon from '@mui/icons-material/AutorenewOutlined';
import CancelIcon1 from '@mui/icons-material/Cancel';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ScheduleIcon from '@mui/icons-material/Schedule';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import 'react-toastify/dist/ReactToastify.css';
import Report from "@mui/icons-material/AssessmentOutlined";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import GlobalConfig from "../../components/GlobalConfig"; // Import your global configuration
// api call 
import { API_ENDPOINTS } from "../../config/api/apiCall";
import CommanTextfieldText from '../commancomponents/CommanTextfieldText';
import Header from '../../Layout/Header';
const Reports = ({ handleBackWinderMachineEntry }) => {

    const [value, setValue] = React.useState(0);

    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [loading, setLoading] = React.useState(false);

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertsevierity, setalertsevierity] = useState('');

    const [Report_All, setReport_All] = useState(true);
    const [Report_SalesOrder, setReport_SalesOrder] = useState(false);


    const [selectedvariety, setSelectedvariety] = useState('');
    const [selectedcolor, setSelectedcolor] = useState('');
    const [selectedgrade, setSelectedgrade] = useState('');

    // const [rows, setTableData] = useState([]);
    let [FinancierYear, setFinancierYear] = useState(1);

    let [CompanyID] = useState(1);
    let masterGroup = '';
    let filterCode = 0;
    let commonParams = {
        FinancierYear,
        masterGroup,
        CompanyID,
        filterCode,
    };
    const [width, setWidth] = useState('');
    const [length, setLength] = useState('');
    const [bf, setBF] = useState('');
    const [gsm, setGSM] = useState('');
    const [selectedCustomer, setSelectedCustomer] = useState('');




    const [CoNo, setCoNo] = useState('');
    const [dataCustomer, setdataCustomer] = useState([]);

    const [SBillToCustomer, setBillToCustomer] = useState(0);

    const handleSelectCustomer = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedCustomer(newValue);
            setBillToCustomer(newValue.CodeId);


            LoadInoviceOrderList(CoNo, newValue.CodeId, reportHeader);
        }
    };

    const handleChangeCONo = (e) => {
        setCoNo(e.target.value);

        LoadInoviceOrderList(e.target.value, SBillToCustomer, reportHeader);

    }


    async function loadBilltoCustomerList() {
        const requestbody =
        {
            ...commonParams,
            masterGroup: 'SO_CUSTOMER',
        }
        try {
            const response = await fetch(API_ENDPOINTS.GET_MASTER_LIST, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestbody)
            });

            if (!response.ok) throw new Error('Unable to load invoice order for update');

            const data = await response.json();

            const updatedData = Array.isArray(data) && !data.includes('') ? [''].concat(data) : data;
            setdataCustomer(updatedData);

            // Handle the data as needed
        } catch (error) {
            showError('Unable to load invoice order for update', 'error');
        }
    }


    
    const [reportHeader, setReportHeader] = useState('');

   

    const getStatusProperties = (status) => {
        let label, color, icon, borderColor;

        switch (status) {
            case 'New':
                label = 'New';
                color = '#33691e';
                icon = <ScheduleIcon />;
                borderColor = '#1976d2';
                break;
            case 'Processed':
                label = 'Processed';
                color = '#689f38';
                icon = <PublishedWithChangesIcon />;
                borderColor = '#388e3c';
                break;
            case 'UnderAmendment':
                label = 'Under Amendment';
                color = '#455a64';
                icon = <Amendicon />;
                borderColor = '#f57c00';
                break;
            case 'Cancelled':
                label = 'Cancelled';
                color = '#ff7043';
                icon = <CancelIcon1 />;
                borderColor = '#d32f2f';
                break;
            case 'Approved':
                label = 'Approved';
                color = '#009688';
                icon = <CheckCircleOutlineIcon />;
                borderColor = '#689f38';
                break;
            case 'Invoiced':
                label = 'Invoiced';
                color = '#2e7d32';
                icon = <ReceiptIcon />;
                borderColor = '#689f38';
                break;
            default:
                label = 'Unknown';
                color = '#9e9e9e'; // Grey color
                icon = null;
                borderColor = '#757575';
        }

        return { label, color, icon, borderColor };
    };

    const StatusCell = ({ value }) => {
        const { label, color, icon, borderColor } = getStatusProperties(value);
        return (
            <Chip
                label={label}
                style={{ backgroundColor: color, color: '#fff', height: '80%', borderColor: borderColor }}
                icon={icon}
            />
        );
    };

    const SizeCell_1 = ({ row }) => {
        const size = `${row.Width} x ${row.Length}`;

        return (
            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center' }}>
                {size}
            </div>
        );
    };


    const SizeCell_2 = ({ row }) => {
        const size = `${row._Width} x ${row._Length}`;

        return (
            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center' }}>
                {size}
            </div>
        );
    };
    const SizeCell_3 = ({ row }) => {
        const size = `${row.Width} x ${row.Length}`;

        return (
            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center' }}>
                {size}
            </div>
        );
    };

    const columns = [
        { field: 'IndentNo', headerName: 'Order No', width: 90 },
        { field: 'IndentDate', headerName: 'Order Date', width: 80 },
        {
            field: 'Status', headerName: 'Status', width: 160, renderCell: (params) => <StatusCell value={params.value} />, // Use custom cell renderer
        },
        { field: 'BillToCustomer', headerName: 'Bill to Customer', width: 250 },
        { field: 'BillToState', headerName: 'Bill to State', width: 120 },
        { field: 'ShipToCustomer', headerName: 'Ship to Customer', width: 250 },
        { field: 'ShipToState', headerName: 'Ship to State', width: 120 },
        { field: 'Variety', headerName: 'Variety', width: 90 },
        { field: 'GSM', headerName: 'GSM', width: 50 },
        {
            field: 'Size', headerName: 'Size', width: 80, renderCell: (params) => <SizeCell_1 row={params.row} />, // Use custom cell renderer
        },
        { field: 'Color', headerName: 'Color', width: 50 },
        { field: 'Unit', headerName: 'Unit', width: 50 },
        { field: 'OrderQty', headerName: 'Order Qty', width: 80 },
        { field: 'ConfirmedQty', headerName: 'Confirmed Qty', width: 90 },
        { field: 'AvailableQty', headerName: 'Available Qty', width: 90 },
        { field: 'ShippedQty', headerName: 'Shipped Qty', width: 90 },
    ];

    const [rows, setRows] = useState([]);


    const columns1 = [
        { field: '_CONo', headerName: 'Order No', width: 90 },
        { field: '_CODate', headerName: 'Order Date', width: 80 },
        {
            field: '_Status', headerName: 'Status', width: 160, renderCell: (params) => <StatusCell value={params.value} />, // Use custom cell renderer
        },
        { field: '_PartyNo', headerName: 'PartyNo', width: 90 },
        { field: '_BillToCustomer', headerName: 'Bill to Customer', width: 250 },
        { field: '_BillToState', headerName: 'Bill to State', width: 120 },
        { field: '_ShipToCustomer', headerName: 'Ship to Customer', width: 250 },
        { field: '_ShipToState', headerName: 'Ship to State', width: 120 },
        { field: '_ShipToArea', headerName: 'Ship To Area', width: 120 },
        { field: '_Variety', headerName: 'Variety', width: 90 },
        { field: '_GSM', headerName: 'GSM', width: 50 },
        {
            field: 'Size', headerName: 'Size', width: 80, renderCell: (params) => <SizeCell_2 row={params.row} />, // Use custom cell renderer
        },
        { field: '_Color', headerName: 'Color', width: 50 },
        { field: '_Unit', headerName: 'Unit', width: 50 },
        { field: '_OrderQty', headerName: 'Order Qty', width: 80 },
        { field: '_ConfirmedQty', headerName: 'Confirmed Qty', width: 90 },
        { field: '_AvailableStock', headerName: 'Available Qty', width: 90 },
        { field: '_WIPQty', headerName: 'WIP Qty', width: 90 },
        { field: '_ShippedQty', headerName: 'Shipped Qty', width: 90 },
        { field: '_BalanceQty', headerName: 'Balance Qty', width: 90 },
        { field: '_StockStatus', headerName: 'Stock Status', width: 90 },

    ];

    const [rows1, setRows1] = useState([]);
    const [rows2, setRows2] = useState([]);
    const [rows3, setRows3] = useState([]);
    const [rows4, setRows4] = useState([]);

    const columnsStockSummary = [
        { field: '_CONo', headerName: 'Order No', width: 90 },
        { field: '_CODate', headerName: 'Order Date', width: 80 },
        {
            field: '_Status', headerName: 'Status', width: 160, renderCell: (params) => <StatusCell value={params.value} />, // Use custom cell renderer
        },
        { field: '_PartyNo', headerName: 'PartyNo', width: 90 },
        { field: '_BillToCustomer', headerName: 'Bill to Customer', width: 250 },
        { field: '_BillToState', headerName: 'Bill To State', width: 120 },
        { field: '_ShipToCustomer', headerName: 'Ship to Customer', width: 250 },
        { field: '_ShipToState', headerName: 'Ship to State', width: 120 },
        { field: '_ShipToArea', headerName: 'Ship To Area', width: 120 },
        { field: '_Variety', headerName: 'Variety', width: 90 },
        { field: '_GSM', headerName: 'GSM', width: 50 },
        {
            field: 'Size', headerName: 'Size', width: 80, renderCell: (params) => <SizeCell_2 row={params.row} />, // Use custom cell renderer
        },
        { field: '_Color', headerName: 'Color', width: 50 },
        { field: '_Unit', headerName: 'Unit', width: 50 },
        { field: '_OrderQty', headerName: 'Order Qty', width: 80 },
        { field: '_ConfirmedQty', headerName: 'Confirmed Qty', width: 90 },
        { field: '_AvailableStock', headerName: 'Available Qty', width: 90 },
        { field: '_WIPQty', headerName: 'WIP Qty', width: 90 },
        { field: '_ShippedQty', headerName: 'Shipped Qty', width: 90 },
        { field: '_BalanceQty', headerName: 'Balance Qty', width: 90 },
        { field: '_StockStatus', headerName: 'Stock Status', width: 90 },

    ];

    const columnsInvoiceSummary = [
        { field: 'InvoiceNo', headerName: 'Invoice No', width: 90 },
        { field: 'InvoiceDate', headerName: 'Invoice Date', width: 100 },
        { field: 'ConfirmationNo', headerName: 'CO No', width: 90 },
        { field: 'ConfirmationDate', headerName: 'CO Date', width: 100 },
        { field: 'PartyNo', headerName: 'PartyNo', width: 90 },
        { field: 'BillToCustomer', headerName: 'Bill to Customer', width: 250 },
        { field: 'ShipToCustomer', headerName: 'Ship to Customer', width: 250 },
        { field: 'ShipToCity', headerName: 'Ship to City', width: 120 },
        { field: 'ShipToState', headerName: 'Ship To State', width: 120 },
        { field: 'Variety', headerName: 'Variety', width: 90 },
        { field: 'GSM', headerName: 'GSM', width: 50 },
        {
            field: 'Size', headerName: 'Size', width: 80, renderCell: (params) => <SizeCell_3 row={params.row} />, // Use custom cell renderer
        },
        { field: 'ShippedQty', headerName: 'Shipped Qty', width: 80 },
        { field: 'TotalQty', headerName: 'Total Qty', width: 90 },
        { field: 'GrossAmount', headerName: 'Gross Amt.', width: 90 },
        { field: 'DiscountAmount', headerName: 'Discount Amt.', width: 90 },
        { field: 'InsuranceAmount', headerName: 'Insurance Amt.', width: 90 },
        { field: 'FrieghtAmount', headerName: 'Frieght Amt.', width: 90 },
        { field: 'SericeChargeAmount', headerName: 'Serice Charge Amt.', width: 90 },
        { field: 'TaxableAmount', headerName: 'Taxable Amt.', width: 90 },
        { field: 'CessAmount', headerName: 'Cess Amt.', width: 90 },
        { field: 'SGSTAmount', headerName: 'SGST Amt.', width: 90 },
        { field: 'CGSTAmount', headerName: 'CGST Amt.', width: 90 },
        { field: 'IGSTAmount', headerName: 'IGST Amt.', width: 90 },
        { field: 'TaxAmount', headerName: 'Tax Amt.', width: 90 },
        { field: 'InvoiceAmount', headerName: 'Invoice Amt.', width: 90 },
    ];

    const columnsStockWiseSummary = [
        { field: 'Variety', headerName: 'Variety', width: 100 },
        { field: 'Grade', headerName: 'Grade', width: 50 },
        { field: 'GSM', headerName: 'GSM', width: 50 },
        { field: 'BF', headerName: 'BF', width: 50 },
        { field: 'Color', headerName: 'Color', width: 50 },

        // Unsold (KG)
        { field: 'unsoldSheet', headerName: 'Unsold-Sheet', width: 100 },
        { field: 'unsoldReel', headerName: 'Unsold-Reel', width: 100 },
        { field: 'unsoldTotal', headerName: 'Unsold-Total', width: 100 },

        // Sold (KG)
        { field: 'soldSheet', headerName: 'Sold-Sheet', width: 100 },
        { field: 'soldReel', headerName: 'Sold-Reel', width: 100 },
        { field: 'soldTotal', headerName: 'Sold-Total', width: 100 },

        // Summary (KG)
        { field: 'summaryTotal', headerName: 'Summary Total', width: 100 },
    ];

    const [currentData, setCurrentData] = useState({ columns, rows });

    const handleViewReport = (reportType) => () => {
        setReport_All(false);
        setReport_SalesOrder(true);
        setReportHeader(reportType + " Report");
        if (reportType === 'Sales Order Summary') {
            setCurrentData({ columns, rows });
        }
        else if (reportType === 'CO Summary') {
            setCurrentData({ columns: columns1, rows: rows1 });
        }
        else if (reportType === 'CO Stock Summary') {
            setCurrentData({ columns: columnsStockSummary, rows: rows2 });
        }
        else if (reportType === 'Invoice Summary') {
            setCurrentData({ columns: columnsInvoiceSummary, rows: rows3 });
        }
        else if (reportType === 'Stock Summary') {
            setCurrentData({ columns: columnsStockWiseSummary, rows: rows4 });
        }
        LoadInoviceOrderList(CoNo, SBillToCustomer, reportType + " Report");
    };


    const showSnackbar = () => {
        setSnackbarOpen(true);
    };


    const showError = (message, severity) => {
        setAlertMessage(message);
        setalertsevierity(severity);
        showSnackbar();
        return true;
    };



    const LoadInoviceOrderList = (CoNo, SBillToCustomer, reportHeader) => {
        if (FromDate == null) {
            showError('Please select the from date', 'warning');
        } else if (ToDate == null) {
            showError('Please select the to date', 'warning');
        } else {
            setLoading(true); // Set loading state to true before fetching data

            const formattedFromDate = dayjs(FromDate).format('YYYY-MMM-DD');
            const formattedToDate = dayjs(ToDate).format('YYYY-MMM-DD');

            const Filter = {
                FromDate: formattedFromDate,
                ToDate: formattedToDate,

            };

            let apical;
            let requestBody = {
                cls_Report: Filter,
                ConstructedGlobalValues: {
                    COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                    COMPANY_ID: CompanyID,
                },
                BillToCustomer: SBillToCustomer,
                ConfirmationNo: CoNo
            };

            if (reportHeader === 'Sales Order Summary Report') {
                apical = API_ENDPOINTS.GetIndentSummaryList;
            } else if (reportHeader === 'CO Summary Report') {
                apical = API_ENDPOINTS.GetCOSummaryList;
            } else if (reportHeader === 'CO Stock Summary Report') {
                apical = API_ENDPOINTS.GetCOStockSummaryList;
                requestBody = { // Adjust requestBody structure
                    FromDate: formattedFromDate,
                    ToDate: formattedToDate,
                    ConstructedGlobalValues: {
                        COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                        COMPANY_ID: CompanyID,
                    },
                };
            } else if (reportHeader === 'Invoice Summary Report') {
                apical = API_ENDPOINTS.GetInvoicedSummaryReport;
                requestBody = { // Adjust requestBody structure
                    FromDate: formattedFromDate,
                    ToDate: formattedToDate,
                    ConstructedGlobalValues: {
                        COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                        COMPANY_ID: CompanyID,
                    },
                };
            } else if (reportHeader === 'Stock Summary Report') {
                apical = API_ENDPOINTS.GetInvoicedSummaryReport;
                requestBody = { // Adjust requestBody structure
                    FromDate: formattedFromDate,
                    ToDate: formattedToDate,
                    ConstructedGlobalValues: {
                        COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                        COMPANY_ID: CompanyID,
                    },
                };
            }

            fetch(apical, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Unable to load invoice order details');
                    }
                    return response.json();
                })
                .then(data => {
                    let formattedData;
                    if (reportHeader === 'Sales Order Summary Report') {
                        if (data.IndentSummaryList?.length > 0) {
                            formattedData = data.IndentSummaryList.map((row, index) => {
                                const IndentDate = new Date(row.IndentDate).toLocaleDateString();
                                return { ...row, id: index + 1, IndentDate };
                            });
                            setRows(formattedData);
                            setCurrentData({ columns: columns, rows: formattedData });
                        }
                    }
                    else if (reportHeader === 'CO Summary Report') {
                        if (data._COSummaryList?.length > 0) {
                            formattedData = data._COSummaryList.map((row, index) => {
                                const _CODate = new Date(row._CODate).toLocaleDateString();
                                return { ...row, id: index + 1, _CODate };
                            });
                            setRows1(formattedData);
                            setCurrentData({ columns: columns1, rows: formattedData });
                        }
                        else {
                            setRows1([]);
                            setCurrentData({ columns: columns1, rows: [] });
                        }
                    }
                    else if (reportHeader === 'CO Stock Summary Report') {
                        if (data._COSummaryList?.length > 0) {
                            formattedData = data._COSummaryList.map((row, index) => {
                                const _CODate = new Date(row._CODate).toLocaleDateString();
                                return { ...row, id: index + 1, _CODate };
                            });
                            setRows2(formattedData);
                            setCurrentData({ columns: columnsStockSummary, rows: formattedData });
                        }
                    }
                    // else if (reportHeader === 'Invoice Summary Report') {
                    //     if (data.InvoicedCOReport?.length > 0) {
                    //         formattedData = data.InvoicedCOReport.map((row, index) => {
                    //             const ConfirmationDate = new Date(row.ConfirmationDate).toLocaleDateString();
                    //             const InvoiceDate = new Date(row.InvoiceDate).toLocaleDateString();
                    //             return { ...row, id: index + 1, ConfirmationDate, InvoiceDate };
                    //         });
                    //         setRows3(formattedData);
                    //         setCurrentData({ columns: columnsInvoiceSummary, rows: formattedData });
                    //     }
                    // }
                    // else if (reportHeader === 'Stock Summary Report') {
                    //     if (data.StockList?.length > 0) {
                    //         formattedData = data.StockList.map((row, index) => {
                    //             const ConfirmationDate = new Date(row.ConfirmationDate).toLocaleDateString();
                    //             const InvoiceDate = new Date(row.InvoiceDate).toLocaleDateString();
                    //             return { ...row, id: index + 1, ConfirmationDate, InvoiceDate };
                    //         });
                    //         setRows4(formattedData);
                    //         setCurrentData({ columns: columnsStockWiseSummary, rows: formattedData });
                    //     }
                    // }
                })
                .catch(error => {
                    showError('Unable to load invoice order details', 'error');
                })
                .finally(() => {
                    setLoading(false); // Set loading state to false after fetching data
                });
        }
    };

    useEffect(() => {
        LoadInoviceOrderList(CoNo, SBillToCustomer, reportHeader);
        loadBilltoCustomerList();
    }, []);


    const handletabChange = (index) => {
        setValue(index);
        setReport_All(true);
        setReport_SalesOrder(false);
    };

    const HandleClose = () => {
        setReport_All(true);
        setReport_SalesOrder(false);
    }

    // tab contents 
    const tabNames = [
        'Sales',
        'Invoice',
        'Inventory',
    ];


    const handleDateChange2 = (date) => {
        setFromDate(dayjs(date));
        LoadInoviceOrderList(CoNo, SBillToCustomer, reportHeader);

    };
    const handleDateChange1 = (date) => {
        setToDate(dayjs(date));
        LoadInoviceOrderList(CoNo, SBillToCustomer, reportHeader);

    };



    const handleSubmit = (event) => {
        event.preventDefault();

        if (FromDate == null) {
            showError('Please select the from date', 'warning');
        }
        else if (ToDate == null) {
            showError('Please select the to date', 'warning');
        }
        else {
            LoadInoviceOrderList(CoNo, SBillToCustomer, reportHeader);
        }
    };

    

    const TabContent = ({ index }) => {
        <Header title={'Sales Reports'} subtitle="" callback={handleBackWinderMachineEntry} />
        switch (index) {
            case 0:
                return <Box p={2}>
                    <Card style={{ backgroundColor: "transparent" }}>
                        <Box display="flex" style={{ backgroundColor: "#607d8b" }} flexDirection={'row'} p={'10px'}>
                            <Typography style={{ marginLeft: '5px', fontWeight: 'bold', fontSize: '20px', marginRight: '5px' }}>Sales </Typography>
                            <Box sx={{ display: 'flex', gap: 2, padding: 0.5 }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: 21,  // Adjust the width and height as needed
                                        height: 21,
                                        backgroundColor: '#37474f',
                                        borderRadius: 1,  // 8px as per the default MUI spacing (1 unit = 4px)
                                        border: '1px solid #ccc',
                                    }}
                                >
                                    <Tooltip title="Total Reports count">
                                        <Typography variant="h6" color="textPrimary">
                                            3
                                        </Typography>
                                    </Tooltip>
                                </Box>
                            </Box>
                        </Box>

                        <CardContent>
                            <Box display="flex" flexDirection={'column'}>
                                {/* <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }} onClick={handleViewReport('Sales Order Summary')}>
                                        <Report style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13}  >Sales Order Summary</Typography>
                                    </IconButton>
                                </Box> */}

                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }} onClick={handleViewReport('CO Summary')}>
                                        <Report style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13}>CO Summary</Typography>
                                    </IconButton>
                                </Box>

                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }} onClick={handleViewReport('CO Stock Summary')}>
                                        <Report style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13}>CO Stock Summary</Typography>
                                    </IconButton>
                                </Box>
                            </Box>
                        </CardContent>
                    </Card>
                </Box>;
            case 1:
                return <Box p={2}>
                    <Card style={{ backgroundColor: "transparent" }}>
                        <Box display="flex" style={{ backgroundColor: "#607d8b" }} flexDirection={'row'} p={'10px'}>
                            <Typography style={{ marginLeft: '5px', fontWeight: 'bold', fontSize: '20px', marginRight: '5px' }}>Invoice</Typography>
                            <Box sx={{ display: 'flex', gap: 2, padding: 0.5 }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: 21,  // Adjust the width and height as needed
                                        height: 21,
                                        backgroundColor: '#37474f',
                                        borderRadius: 1,  // 8px as per the default MUI spacing (1 unit = 4px)
                                        border: '1px solid #ccc',
                                    }}
                                >
                                    <Tooltip title="Total Reports count">
                                        <Typography variant="h6" color="textPrimary">
                                            1
                                        </Typography>
                                    </Tooltip>
                                </Box>
                            </Box>
                        </Box>

                        <CardContent>
                            <Box display="flex" flexDirection={'column'}>
                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }} onClick={handleViewReport('Invoice Summary')}>
                                        <Report style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13} >Invoice Summary</Typography>
                                    </IconButton>
                                </Box>
                            </Box>
                        </CardContent>
                    </Card>
                </Box>;
            case 2:
                return <Box p={2}>
                    <Card style={{ backgroundColor: "transparent" }}>

                        <Box display="flex" style={{ backgroundColor: "#607d8b" }} flexDirection={'row'} p={'10px'}>
                            <Typography style={{ marginLeft: '5px', fontWeight: 'bold', fontSize: '20px', marginRight: '5px' }}>Inventory</Typography>

                            <Box sx={{ display: 'flex', gap: 2, padding: 0.5 }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: 21,  // Adjust the width and height as needed
                                        height: 21,
                                        backgroundColor: '#37474f',
                                        borderRadius: 1,  // 8px as per the default MUI spacing (1 unit = 4px)
                                        border: '1px solid #ccc',
                                    }}
                                >
                                    <Tooltip title="Total Reports count">
                                        <Typography variant="h6" color="textPrimary">
                                            9
                                        </Typography>
                                    </Tooltip>
                                </Box>
                            </Box>
                        </Box>

                        <CardContent>
                            <Typography style={{ marginLeft: 'px', fontWeight: 'bold', fontSize: '15px', marginBottom: '5px' }}>Stock Summary</Typography>
                            <Box display="flex" flexDirection={'column'}>
                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }}>
                                        <Report style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13}>Finished house location Summary</Typography>
                                    </IconButton>
                                </Box>
                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }} onClick={handleViewReport('Stock Summary')}>
                                        <Report style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13}>Stock Summary</Typography>
                                    </IconButton>
                                </Box>
                            </Box>
                        </CardContent>
                    </Card>

                    <Card style={{ backgroundColor: "transparent", marginTop: "10px" }}>
                        <CardContent>
                            <Typography style={{ marginLeft: 'px', fontWeight: 'bold', fontSize: '15px', marginBottom: '5px' }}>Stock Report</Typography>

                            <Box display="flex" flexDirection={'column'}>

                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }}>
                                        <Report style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13}>CO Stock Location</Typography>
                                    </IconButton>
                                </Box>

                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }}>
                                        <Report style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13}>Received Location</Typography>
                                    </IconButton>
                                </Box>

                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }}>
                                        <Report style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13}>Shipped Location</Typography>
                                    </IconButton>
                                </Box>

                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }}>
                                        <Report style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13}>Agewise Location</Typography>
                                    </IconButton>
                                </Box>

                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }}>
                                        <Report style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13}>SWO Location</Typography>
                                    </IconButton>
                                </Box>

                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }}>
                                        <Report style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13}>Salvaged Location</Typography>
                                    </IconButton>
                                </Box>

                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }}>
                                        <Report style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13}>Stock Opening Balance</Typography>
                                    </IconButton>
                                </Box>
                            </Box>
                        </CardContent>
                    </Card>
                </Box>;
            default:
                return null;
        }
    };

    const callback = () => {
        handleBackWinderMachineEntry();
    };


    return (
        <Box m='10px'>
            <Header title={'Sales Reports'} subtitle="" callback={callback} />
            <Divider />
            <div >
                <Box display="flex">
                    <Box width={'280px'} display="flex" flexDirection={'column'}>
                        <h3 style={{ marginLeft: '10px' }}>Report Category </h3>

                        <List
                        >
                            {tabNames.map((name, index) => (
                                <ListItem
                                    key={index}
                                    button
                                    selected={value === index}
                                    color="secondary"
                                    onClick={() => handletabChange(index)}
                                >
                                    <FolderIcon style={{ marginRight: '5px', color: '#bbdefb' }} />   <ListItemText primary={name} />
                                </ListItem>
                            ))}
                        </List>
                    </Box>

                    <Divider
                        orientation="vertical"
                        flexItem

                        sx={{
                            margin: '0 10px',
                            borderWidth: '0.5px',
                            borderColor: 'whitesmoke',
                            height: 'auto',  // or specify a height if needed
                        }}
                    />

                    {Report_All &&
                        <Box flexGrow={1} >
                            <TabContent index={value} />
                        </Box>
                    }


                    {Report_SalesOrder &&
                        <Box flexGrow={1} >
                            <form onSubmit={handleSubmit}>
                                <Box>

                                    <Header title={reportHeader} subtitle="" callback={HandleClose} />
                                    <Divider />

                                    <Box m='0px' display="flex" flexDirection={'column'}>
                                        <Grid container spacing={1} justifyContent="start" style={{ marginTop: '0px' }}>
                                            <Grid item lg={1.5} xs={1.5}>
                                                <Typography mt={1} ml={0} style={{ fontSize: '14px' }}>CO Date </Typography>
                                            </Grid>
                                            <Grid item lg={2} xs={4}>
                                                <FormControl fullWidth size="small">
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            label="From date"
                                                            style={{ marginLeft: '10px' }}
                                                            id="FromDate"
                                                            value={dayjs(FromDate)}
                                                            onChange={(date) => handleDateChange2(date)}
                                                            slotProps={{ textField: { size: 'small', } }}
                                                            renderInput={(props) => <TextField {...props} />}
                                                            autoFocus
                                                            format="DD-MMM-YYYY" // Use the appropriate format string
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Grid>

                                            <Grid item lg={2} xs={4}>
                                                <FormControl fullWidth size="small" >
                                                    <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                                        <DatePicker
                                                            label="To date"
                                                            id="ToDate"
                                                            value={dayjs(ToDate)}
                                                            format="DD-MMM-YYYY"
                                                            onChange={(date) => handleDateChange1(date)}
                                                            slotProps={{ textField: { size: 'small', } }}
                                                            renderInput={(props) => <TextField {...props} />}
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={1} justifyContent="start" style={{ marginTop: '0px' }}>
                                            <Grid item lg={1.5} xs={1.5}>
                                                <Typography mt={1} ml={0} style={{ fontSize: '14px' }}>Bill to Customer </Typography>
                                            </Grid>

                                            <Grid item lg={4} xs={4}>
                                                <Autocomplete
                                                    fullWidth
                                                    size="small"
                                                    id="dropdown_Customer" // Different id for Ship to Customer
                                                    value={selectedCustomer}
                                                    onChange={handleSelectCustomer}
                                                    options={dataCustomer}
                                                    getOptionLabel={(option) => option.Description || ''}
                                                    // isOptionEqualToValue={(option, value) => option?.Description === value?.Description}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"

                                                            label="Bill to Customer" />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid item lg={0.7} xs={1.5}>
                                                <Typography mt={1} ml={0} style={{ fontSize: '14px' }}>CO No. </Typography>
                                            </Grid>

                                            <Grid item lg={3} xs={1.5}>
                                                <CommanTextfieldText
                                                    label="Please enter the CO No."
                                                    value={CoNo}
                                                    onChange={handleChangeCONo}
                                                />
                                            </Grid>


                                        </Grid>


                                    </Box>

                                    {/* <Box m='0px' display="flex" justifyContent={'space-between'}>
                                        <Card style={{ backgroundColor: "Transparent" }}>
                                            <CardContent style={{ padding: '10px 10px 30px 10px' }}>
                                                <Box
                                                    marginTop={0}
                                                    mb={2}
                                                    display="grid"
                                                    gridTemplateColumns={{
                                                        xs: 'repeat(1, 1fr)',
                                                        sm: 'repeat(2, 1fr)',
                                                        md: 'repeat(3, 1fr)',
                                                        lg: 'repeat(12, 1fr)',
                                                        xl: 'repeat(12, 1fr)',
                                                    }}
                                                    gridAutoRows="10px"
                                                    gap={{ xs: '35px', sm: '35px', md: '30px', lg: '5px', xl: '5px' }}
                                                >
                                                    <Box
                                                        gridColumn={{
                                                            xs: 'span 4',
                                                            sm: 'span 3',
                                                            md: 'span 1',
                                                            lg: 'span 3',
                                                            xl: 'span 3',
                                                        }}
                                                        display="flex"
                                                        flexDirection="column"
                                                        alignItems="start"
                                                        justifyContent="start"
                                                    >
                                                        <CommonAutocomplete
                                                            label="Variety"
                                                            value={selectedvariety}
                                                            onChange={handleSelectvariety}
                                                            options={dataVariety}
                                                            getOptionLabel={(option) => option.Description || ''}
                                                            error={ProductVarietyError}
                                                            helperText={ProductVarietyError}
                                                        />
                                                    </Box>

                                                    <Box
                                                        gridColumn={{
                                                            xs: 'span 4',
                                                            sm: 'span 1',
                                                            md: 'span 1',
                                                            lg: 'span 1',
                                                            xl: 'span 1',
                                                        }}
                                                        display="flex"
                                                        flexDirection="column"
                                                        alignItems="start"
                                                        justifyContent="start"
                                                    >
                                                        <CommanTextfield
                                                            label="GSM"
                                                            value={gsm}
                                                            onChange={handleChangeGSM}
                                                        />
                                                    </Box>

                                                    <Box
                                                        gridColumn={{
                                                            xs: 'span 4',
                                                            sm: 'span 2',
                                                            md: 'span 1',
                                                            lg: 'span 1',
                                                            xl: 'span 1',
                                                        }}
                                                        display="flex"
                                                        flexDirection={'column'}
                                                        alignItems="start"
                                                        justifyContent="start"
                                                    >
                                                        <CommanTextfield
                                                            label="BF"
                                                            value={bf}
                                                            onChange={handleChangeBF}
                                                        />
                                                    </Box>

                                                    <Box
                                                        gridColumn={{
                                                            xs: 'span 4',
                                                            sm: 'span 1',
                                                            md: 'span 1',
                                                            lg: 'span 2',
                                                            xl: 'span 2',
                                                        }}
                                                        display="flex"
                                                        flexDirection={"column"}
                                                        alignItems="start"
                                                        justifyContent="start"
                                                    >
                                                        <CommonAutocomplete
                                                            label="Grade"
                                                            value={selectedgrade}
                                                            onChange={handleSelectgrade}
                                                            options={dataGrade}
                                                            getOptionLabel={(option) => option.Description || ''}
                                                            error={GradeError}
                                                            helperText={GradeError}
                                                        />
                                                    </Box>

                                                    <Box
                                                        gridColumn={{
                                                            xs: 'span 4',
                                                            sm: 'span 1',
                                                            md: 'span 1',
                                                            lg: 'span 2',
                                                            xl: 'span 2',
                                                        }}
                                                        display="flex"
                                                        flexDirection={"column"}
                                                        alignItems="start"
                                                        justifyContent="start"
                                                    >
                                                        <CommonAutocomplete
                                                            label="Order Type"
                                                            value={selectedordertype}
                                                            onChange={handleSelectordertype}
                                                            options={dataOrderType}
                                                            getOptionLabel={(option) => option.Description || ''}

                                                        />
                                                    </Box>

                                                    <Box
                                                        gridColumn={{
                                                            xs: 'span 4',
                                                            sm: 'span 4',
                                                            md: 'span 4',
                                                            lg: 'span 1',
                                                            xl: 'span 1',
                                                        }}
                                                        mt={1.5}
                                                        ml={1}
                                                        display="flex"
                                                        flexDirection={"column"}
                                                        alignItems="start"
                                                        justifyContent="start"
                                                    >
                                                        <Button variant='contained' onClick={handleSubmitFilter} size='small' color='success'
                                                            startIcon={<Search />} >
                                                            Search
                                                        </Button>
                                                    </Box>
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </Box> */}

                                    {/* <Divider style={{ borderColor: '#424852', marginTop: '5px', marginBottom: "0px" }} />
                                    <Box
                                        sx={{
                                            m: '15px',

                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                        }}
                                    >
                                        <Typography variant="h4" fontWeight={600} color="#fff">
                                            {reportHeader}
                                        </Typography>

                                        <Tooltip title="Close" onClick={HandleClose}>
                                            <IconButton >
                                                <CancelIcon style={{ color: "#ef5350" }} />
                                            </IconButton>
                                        </Tooltip>
                                    </Box> */}


                                    <Box
                                        margin='5px 0px 0px 0px'
                                        gridAutoRows={'70vh'}
                                        display="grid"
                                        gridTemplateColumns="repeat(20, 1fr)"
                                        gap={{ xs: '50px', sm: '50px', md: '50px', lg: '10px', xl: '10px' }}
                                    >
                                        <Box
                                            gridColumn="span 20"
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                            sx={{
                                                "& .custom-header": {
                                                    fontWeight: 'bold',  // set bold font
                                                    fontSize: '0.85rem',  // adjust font size                                 
                                                },
                                                "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                                                    color: `${colors.grey[100]} !important`,
                                                },
                                                "& .MuiCheckbox-root": {
                                                    color: `${colors.greenAccent[200]} !important`,
                                                },
                                            }}
                                        >
                                            <DataGrid
                                                rows={currentData.rows}
                                                columns={currentData.columns}
                                                pageSize={5}
                                                rowHeight={30}
                                                slots={{ toolbar: GridToolbar }}
                                                slotProps={{
                                                    toolbar: {
                                                        showQuickFilter: true,
                                                    },
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                            </form>
                        </Box>
                    }
                </Box>
            </div>
        </Box>
    )
}

export default Reports;
